import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { spacing1x } from '../../styles/spacing.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { IconCircle } from './IconCircle.js';
import { IconCircleCrescent } from './IconCircleCrescent.js';
import { IconCircleFilled } from './IconCircleFilled.js';
import { IconCircleLine } from './IconCircleLine.js';
import { IconCircleTarget } from './IconCircleTarget.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var _excluded = ["children", "hideChildren", "variant"];
var StatusIconWrapper = styled.span.withConfig({
  displayName: "Status__StatusIconWrapper",
  componentId: "sc-18qqd2e-0"
})(function (_ref) {
  var theme = _ref.theme,
    variant = _ref.variant;
  var alertColors = theme.alertColors,
    neutralColors = theme.neutralColors;
  var alertColorMap = {
    approved: alertColors.success,
    changes: alertColors.success,
    draft: neutralColors.rhino,
    error: alertColors.error,
    unset: void 0,
    expired: neutralColors.rhino,
    published: alertColors.success,
    review: alertColors.warning
  };
  return {
    color: alertColorMap[variant]
  };
});
var StatusWrapper = styled.span.withConfig({
  displayName: "Status__StatusWrapper",
  componentId: "sc-18qqd2e-1"
})(["&&{font-size:12px;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;white-space:normal;}&& ", "{line-height:0;margin-inline-end:", ";position:relative;top:-1px;}"], StatusIconWrapper, spacing1x);
var iconMap = {
  approved: IconCircle,
  changes: IconCircleLine,
  draft: IconCircle,
  error: IconCircleTarget,
  unset: void 0,
  expired: IconCircleLine,
  published: IconCircleFilled,
  review: IconCircleCrescent
};
var iconStylesMap = {
  expired: {
    transform: "rotate(45deg)"
  }
};
var statusComponents = {
  StatusWrapper: StatusWrapper
};
var Status = /*#__PURE__*/React.forwardRef(function Status2(props, ref) {
  var children = props.children,
    hideChildren = props.hideChildren,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "draft" : _props$variant,
    rest = _objectWithoutProperties(props, _excluded);
  var Icon = iconMap[variant];
  return hideChildren ? /*#__PURE__*/jsxs(Fragment, {
    children: [Icon && /*#__PURE__*/jsx(StatusIconWrapper, _objectSpread(_objectSpread({
      variant: variant,
      ref: ref
    }, rest), {}, {
      children: /*#__PURE__*/jsx(Icon, {
        width: 8,
        height: 8,
        style: iconStylesMap[variant]
      })
    })), /*#__PURE__*/jsx(VisuallyHidden, {
      children: children
    })]
  }) : /*#__PURE__*/jsxs(StatusWrapper, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [Icon && /*#__PURE__*/jsx(StatusIconWrapper, {
      variant: variant,
      children: /*#__PURE__*/jsx(Icon, {
        width: 8,
        height: 8,
        style: iconStylesMap[variant]
      })
    }), children]
  }));
});
Status.displayName = "Status";

export { Status, statusComponents };
